import React from 'react';
import { injectIntl } from 'react-intl-next';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { CustomMediaPlayerBase as EmotionCustomMediaPlayerBase } from './index-emotion';
import { CustomMediaPlayerBase as CompiledCustomMediaPlayerBase } from './index-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
import { withMediaAnalyticsContext } from '@atlaskit/media-common';
export var CustomMediaPlayerBase = function CustomMediaPlayerBase(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledCustomMediaPlayerBase, props) : /*#__PURE__*/React.createElement(EmotionCustomMediaPlayerBase, props);
};
var packageName = "@atlaskit/media-ui";
var packageVersion = "28.0.4";

// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
export var CustomMediaPlayer = withMediaAnalyticsContext({
  packageVersion: packageVersion,
  packageName: packageName,
  componentName: 'customMediaPlayer',
  component: 'customMediaPlayer'
})(withAnalyticsEvents()(injectIntl(CustomMediaPlayerBase)));